import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'

import { ScrollingModule } from '@angular/cdk/scrolling'

import {
  NbActionsModule,
  NbAlertModule,
  NbButtonModule,
  NbCardModule,
  NbIconModule,
  NbInputModule,
  NbListModule,
  NbProgressBarModule,
  NbRadioModule,
  NbSelectModule,
  NbTabsetModule,
  NbToggleModule,
  NbUserModule,
} from '@nebular/theme'
import { NgxEchartsModule } from 'ngx-echarts'

import { FormsModule } from '@angular/forms'
import { ThemeModule } from '../../@theme/theme.module'
import { EditUserComponent } from './edit_user.component'

@NgModule( {
  imports: [
    ScrollingModule, // for CDK Scrolling of the role pop-up
    ReactiveFormsModule,
    FormsModule,
    ThemeModule,
    NbCardModule,
    NbUserModule,
    NbButtonModule,
    NbTabsetModule,
    NbActionsModule,
    NbInputModule,
    NbRadioModule,
    NbSelectModule,
    NbListModule,
    NbIconModule,
    NbButtonModule,
    NgxEchartsModule,
    NbProgressBarModule,
    NbAlertModule,
    NbToggleModule,
  ],
  declarations: [
    EditUserComponent,
  ],
  exports: [
    EditUserComponent,
  ],
} )
export class EditUserModule { }
